var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 156,
    viewBox: "0 0 147 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56294 132.768C3.97014 130.648 5.47455 128.904 7.5123 128.191L21.646 123.243C25.0618 122.048 28.7572 124.093 29.5583 127.622L34.0771 147.529C35.0102 151.639 31.5658 155.424 27.3857 154.88L6.3846 152.15C2.92267 151.7 0.555873 148.425 1.21431 144.997L3.56294 132.768Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.913 12.6104C128.491 8.16241 132.863 4.80178 137.052 6.35423L139.977 7.43804C141.626 8.04898 142.928 9.3459 143.546 10.9922L144.406 13.2843C145.748 16.8631 143.483 20.7759 139.711 21.3936L136.3 21.9522C132.838 22.5191 129.619 20.0372 129.287 16.5449L128.913 12.6104Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.581 117.383C128.313 114.445 131.226 112.249 133.977 113.314C135.052 113.731 135.894 114.594 136.284 115.679L136.383 115.955C137.226 118.305 135.743 120.846 133.282 121.267C130.974 121.662 128.819 120.006 128.607 117.674L128.581 117.383Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8427 13.6181C18.4421 10.4723 21.3737 7.9331 24.4301 8.77845L27.072 9.50915C28.133 9.80259 29.0203 10.5311 29.5146 11.5147C30.7252 13.9236 29.1822 16.8044 26.5061 17.1315L23.7853 17.4641C21.3602 17.7605 19.1513 16.0417 18.8427 13.6181Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8677 31.6791C37.0845 27.6202 40.6294 24.0445 44.6949 24.7926L107.114 36.279C110.262 36.8582 112.365 39.8514 111.844 43.0089L106.384 76.0969C106.304 76.5809 106.282 77.0726 106.317 77.5619L108.123 102.726C108.362 106.054 105.781 108.913 102.446 109.014L49.7149 110.62C46.4039 110.721 43.6651 108.065 43.6651 104.752V62.3188C43.6651 61.9214 43.6272 61.5248 43.5519 61.1346L37.8677 31.6791Z",
    fill: "#F1F1F1",
    stroke: "#959595",
    strokeWidth: 0.378774
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 65,
    r: 8,
    fill: "#E5E5E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 70.5,
    r: 2.5,
    fill: "#959595"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 65,
    r: 8,
    fill: "#E5E5E5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 70.5,
    r: 2.5,
    fill: "#959595"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95C62.9998 91.2645 76.81 80.8642 91 89.0827",
    stroke: "#959595",
    strokeWidth: 0.757547
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68 35.3333L71.6 29L74 29.6667L69.5 35.3333L73.4 41L70.4 50L72.8 41L68 35.3333Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFallback);
export default __webpack_public_path__ + "static/media/errorFallback.489b112ed73ba521928ec17be4fdc219.svg";
export { ForwardRef as ReactComponent };